var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes,attrs:{"data-preload":[_vm.$options.name]}},_vm._l((_vm.actionsList.actions),function(action,key){return _c('button',{key:key,class:[
      'action',
      action.class,
      { 'one-action': _vm.actionsList.actions.length === 1 },
    ],attrs:{"title":action.title,"tabindex":action.tabindex},on:{"click":function($event){return _vm.handleActionClick(_vm.productId, action.type, action.listOfOrigin)}}},[_c('div',[_c('Icon',{staticClass:"icon",attrs:{"name":action.icon,"height":"18","original":true}})],1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }